import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from "connected-react-router";
import Dropdown from 'react-bootstrap/Dropdown';

import Logo from './components/Logo';
import { isAdmin, isViewer } from '../../utils/role';
import { Constants } from '../../helpers/Constants';
import { setLanguage } from '../../redux/actions/localizeAction'
import Modal from '../Modal';

import './header.scss';


class Header extends React.Component {
    static propTypes = {
        language: PropTypes.string.isRequired,
        profile: PropTypes.object,
        path: PropTypes.string,
        user: PropTypes.object,
        login: PropTypes.func.isRequired,
        logout: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        setLanguage: PropTypes.func.isRequired
    }

    static contextTypes = {
        translate: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            about: false
        }
    }

    getTitle(path) {
        switch (path) {
            case '/profile':
                return this.context.translate('Header.Profile');
            case '/':
            case '/menu':
                return this.context.translate('Header.Menu');
            case '/history':
                return this.context.translate('Header.Payments');
            case '/view/daily':
                return this.context.translate('Header.OrderDay');
            case '/view/monthly':
                return this.context.translate('Header.OrderMonth');
            case '/view/order':
                return this.context.translate('Header.OrderSummary');
            case '/admin/account':
                return this.context.translate('Header.Accounts');
            case '/admin/diner':
                return this.context.translate('Header.Diners');
            case '/admin/group':
                return this.context.translate('Header.Groups');
            case '/admin/lunch':
                return this.context.translate('Header.Lunch');
            case '/admin/payment':
                return this.context.translate('Header.AdminPayments');
            case '/admin/billing':
                return this.context.translate('Header.Billing');
            case '/admin/alergen':
                return this.context.translate('Header.Alergens');
            case '/admin/emails':
                return this.context.translate('Header.Emails');
            case '/admin/settings':
                return this.context.translate('Header.Settings');
            case '/admin/notice':
                return this.context.translate('Header.Notice');
            case '/admin/order':
                return this.context.translate('Header.OrderAdmin');
            default:
                return '';
        }
    }

    render() {
        let isUser = this.props.profile.loaded;
        let showAdmin = isAdmin(this.props.profile);
        let showViewer = isViewer(this.props.profile);
        let lang = this.props.language === 'cs' ? 'EN' : 'CS';
        let langChange = this.props.language === 'cs' ? 'en' : 'cs';
        let title = this.getTitle(this.props.path).toUpperCase();

        return (
            <div className="imsp-header">
                <div className="imsp-header-content">
                    <Logo
                        onClick={() => this.props.push("/")}
                    />
                    <a
                        className="signpost"
                        href={Constants.stsAuthority}
                    >
                        <div className="signpost-img"></div>
                    </a>
                    <div className="header-title">
                        <div className="title-text">{title}</div>
                    </div>
                    <div className="content">
                        {!isUser &&
                            <>
                                <div
                                    className="header-link"
                                    onClick={() => this.props.login()}
                                >{this.context.translate('Header.Login')}</div>
                                {/* <a
                                className="header-link"
                                href={`${Constants.stsAuthority}/Account/Register`}
                                onClick={() => { }}
                            >{this.context.translate('Header.Register')}</a> */}
                            </>
                        }
                        {isUser &&
                            <Dropdown alignRight>
                                <Dropdown.Toggle
                                    variant="custom"
                                    id="user-menu-dropdown"
                                    className="header-link"
                                >
                                    <span className="account-ico"><i className="fa fa-user" aria-hidden="true"></i></span>
                                    <span className="account-name">{this.props.profile.data.name}</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => this.setState({ about: true })}>{this.context.translate('Header.About.Title')}</Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={() => this.props.push('/profile')}>{this.context.translate('Header.Profile')}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.props.push('/')}>{this.context.translate('Header.Menu')}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.props.push('/history')}>{this.context.translate('Header.Payments')}</Dropdown.Item>
                                    {showViewer &&
                                        <>
                                            <Dropdown.Divider />
                                            <Dropdown.Item onClick={() => this.props.push('/view/daily')}>{this.context.translate('Header.OrderDay')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/view/monthly')}>{this.context.translate('Header.OrderMonth')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/view/order')}>{this.context.translate('Header.OrderSummary')}</Dropdown.Item>
                                        </>
                                    }
                                    {showAdmin &&
                                        <>
                                            <Dropdown.Divider />
                                            <Dropdown.Item onClick={() => this.props.push('/admin/account')}>{this.context.translate('Header.Accounts')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/diner')}>{this.context.translate('Header.Diners')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/group')}>{this.context.translate('Header.Groups')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/lunch')}>{this.context.translate('Header.Lunch')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/payment')}>{this.context.translate('Header.AdminPayments')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/billing')}>{this.context.translate('Header.Billing')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/alergen')}>{this.context.translate('Header.Alergens')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/emails')}>{this.context.translate('Header.Emails')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/notice')}>{this.context.translate('Header.Notice')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/settings')}>{this.context.translate('Header.Settings')}</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.props.push('/admin/order')}>{this.context.translate('Header.OrderAdmin')}</Dropdown.Item>
                                        </>
                                    }
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={() => this.props.logout()}>{this.context.translate('Header.Logout')}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        }
                        {showViewer && false &&
                            <>
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant="custom"
                                        id="viewer-menu-dropdown"
                                        className="header-link"
                                    >{this.context.translate('Header.Reports')}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => this.props.push('/view/order')}>{this.context.translate('Header.OrderSummary')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.props.push('/view/daily')}>{this.context.translate('Header.OrderDay')}</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </>
                        }
                        {showAdmin && false &&
                            <>
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant="custom"
                                        id="admin-menu-dropdown"
                                        className="header-link"
                                    >{this.context.translate('Header.Administration')}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => this.props.push('/admin/account')}>{this.context.translate('Header.Accounts')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.props.push('/admin/diner')}>{this.context.translate('Header.Diners')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.props.push('/admin/group')}>{this.context.translate('Header.Groups')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.props.push('/admin/lunch')}>{this.context.translate('Header.Lunch')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.props.push('/admin/payment')}>{this.context.translate('Header.AdminPayments')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.props.push('/admin/billing')}>{this.context.translate('Header.Billing')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.props.push('/admin/alergen')}>{this.context.translate('Header.Alergens')}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.props.push('/admin/settings')}>{this.context.translate('Header.Settings')}</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </>
                        }
                        <div
                            className="header-link"
                            onClick={() => this.props.setLanguage(langChange)}
                        >{lang}</div>
                    </div>

                    {this.state.about &&
                        <Modal
                            modalClass="about-modal"
                            onClose={() => this.setState({ about: false })}
                            onSubmit={() => this.setState({ about: false })}
                            title={this.context.translate("Header.About.Title")}
                            show={true}
                            closeOnClick={true}
                        >
                            <div className="list">
                                <div className="info">
                                    <div className="label">{this.context.translate('Header.About.Name')}</div>
                                    <div className="value">{this.context.translate('Header.About.App')}</div>
                                </div>
                                <div className="info">
                                    <div className="label">{this.context.translate('Header.About.Version')}</div>
                                    <div className="value">{process.env.REACT_APP_VERSION}</div>
                                </div>
                                <div className="delimiter"></div>
                                <div className="info">
                                    <div className="label">{this.context.translate('Header.About.By')}</div>
                                    <div className="value"><a target="_blank" href="https://mpenkala.cz" rel="noopener noreferrer">Michal Penkala</a></div>
                                </div>
                                {/* <div className="info">
                                    <div className="value">{this.context.translate('Header.About.Copyright')}</div>
                                </div> */}
                                <div className="buttons">
                                    <button
                                        className="btn btn-light"
                                        onClick={() => this.setState({ about: false })}
                                    >{this.context.translate('Btn.Close')}</button>
                                </div>
                            </div>
                        </Modal>
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        profile: state.profile,
        path: state.router.location.pathname,
        language: state.localize.language
    }),
    {
        push,
        setLanguage
    }
)(Header);